export const REPORT_ACTIONS = {
  WARN: "warned",
  MUTE_USER: "user_muted",
  DELETE_CONTENT: "content_deleted",
  BAN_USER: "user_banned",
  DISMISS: "dismissed",
};
